import React, { useState } from "react";
import Form from "react-bootstrap/Form";
import Hide from "./svg/Hide";
import Show from "./svg/Show";

const InputPassword = ({ ...params }) => {
  const [isShow, setIsShow] = useState(true);

  const handleShow = () => {
    setIsShow(!isShow);
  };
  return (
    <>
      <div className="w-100 position-relative">
        <Form.Control
          type={isShow ? "password" : "text"}
          className="py-3"
          {...params}
        />
        <div
          className="position-absolute top-50 translate-middle-y"
          style={{ right: "12px" }}
        >
          <div onClick={handleShow}>{isShow ? <Show /> : <Hide />}</div>
        </div>
      </div>
    </>
  );
};

export default InputPassword;
